import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default [
  {
    path: "/personal-player",
    redirect: "/personal-player",
    name: "PersonalPlayerInfo",
    component: LAYOUT,
    meta: {
      order: 50,
      roles: ManagerType.Single,
      title: "个人运动员",
    },
    children: [
      {
        path: "",
        name: "PersonalPlayerInfoPage",
        component: () => import("@/views/personal/PersonalPlayerInfoPage.vue"),
        meta: {
          title: "个人运动员",
          roles: ManagerType.Single,
          icon: "ant-design:user-outlined",
        },
      },
    ],
  },
  {
    path: "/personal-join",
    redirect: "/personal-join",
    name: "PersonalJoin",
    component: LAYOUT,
    meta: {
      order: 60,
      roles: ManagerType.Single,
      title: "申请加入队伍",
      hideMenu: import.meta.env.VITE_PROJECT_ALIAS != "swm",
    },
    children: [
      {
        path: "",
        name: "PersonalJoinPage",
        component: () => import("@/views/personal/PersonalJoinPage.vue"),
        meta: {
          title: "申请加入队伍",
          icon: "ix:join",
          roles: ManagerType.Single,
          hideMenu: import.meta.env.VITE_PROJECT_ALIAS != "swm",
        },
      },
    ],
  },
  {
    path: "/personal-join-review",
    redirect: "/personal-join-review",
    name: "PersonalJoinReview",
    component: LAYOUT,
    meta: {
      order: 70,
      roles: ManagerType.Unit,
      title: "加入队伍审核",
      hideMenu: import.meta.env.VITE_PROJECT_ALIAS != "swm",
    },
    children: [
      {
        path: "",
        name: "PersonalJoinReviewPage",
        component: () => import("@/views/personal/PersonalJoinReviewPage.vue"),
        meta: {
          title: "加入队伍审核",
          icon: "ix:join",
          roles: ManagerType.Unit,
          hideMenu: import.meta.env.VITE_PROJECT_ALIAS != "swm",
        },
      },
    ],
  },
] as RouteRecordRaw[];
